module.exports = "/_next/static/images/slide-3-3255f6ba5be367f1e30d62dc040fd657.jpg";